import React from "react";
import { useState } from "react";

import format_date_formal from "../../App/validation/format_date_formal";
import Modal from "../common_modal/Modal";

const POPUP_SMALL = ({
  geo_layer_id,
  feature,
  fields,
  type_2,
  onClose,
  handleFullScreen,
  onBanjirGenerate,
}) => {
  const { properties } = feature || {};

  const [state, setState] = useState({
    modal_desc: false,
    value_state: "",
  });

  const { modal_desc, value_state } = state;

  const toggle_desc = (value_state) => {
    setState((prevState) => ({
      ...prevState,
      modal_desc: !prevState.modal_desc,
      value_state: value_state,
    }));
  };

  // Filter out style fields
  const filteredFields = fields.filter(
    (field) => !!field?.isStyle === false && !field?.parent_uuid,
  );

  // --- SAFETY HELPER ---
  const safeStringify = (val) => {
    if (val == null) return "-";
    if (val instanceof Date) return val.toString();
    if (typeof val === "object") {
      try {
        return JSON.stringify(val);
      } catch (e) {
        return "Invalid Object Data";
      }
    }
    return val;
  };

  const renderFieldValue = (field, value) => {
    switch (field.type) {
      case "text":
        return <div className="text_medium">{safeStringify(value)}</div>;
      case "id_data":
        return <div className="text_medium">{feature?._id}</div>;

      case "number":
        const formattedNumber =
          !isNaN(value) && value !== null && value !== ""
            ? new Intl.NumberFormat("id-ID", { style: "decimal" }).format(value)
            : safeStringify(value);
        return <div className="text_medium">{formattedNumber}</div>;

      case "currency":
        const formattedCurrency =
          !isNaN(value) && value !== null && value !== ""
            ? new Intl.NumberFormat("id-ID", { style: "decimal" }).format(value)
            : safeStringify(value);
        return <div className="text_medium">{formattedCurrency}</div>;

      case "date":
        const formattedDate = format_date_formal(value);
        return (
          <div className="text_medium">{safeStringify(formattedDate)}</div>
        );

      case "last_edited": {
        let fmtdDate = "-";
        const rawDate = feature?.updated_at;

        // Check if it exists and isn't the literal string "undefined"
        if (rawDate && rawDate !== "undefined") {
          const dateObj = new Date(rawDate);

          // Check if it's a valid date
          if (!isNaN(dateObj.getTime())) {
            fmtdDate = dateObj.toLocaleString("id-ID", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
              timeZone: "Asia/Jakarta",
            });
          } else {
            // Fallback for invalid date strings
            fmtdDate = String(rawDate); // You can use safeStringify(rawDate) here if needed
          }
        }

        return <div className="text_medium">{fmtdDate}</div>;
      }

      case "auto_generate_user_name": {
        const user = feature?.user;

        // Extract display name, assuming 'value' is available in your switch scope.
        // If not, it falls back to "-"
        const displayName = user?.full_name || user?.name || value || "-";

        // Extract avatar URL
        const smallAvatar =
          user?.profile_picture?.url_compressed || user?.profile_picture?.url;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              overflow: "hidden",
            }}
            title={displayName !== "-" ? displayName : ""}
          >
            {smallAvatar ? (
              <img
                src={smallAvatar}
                alt={displayName}
                style={{
                  width: "19px",
                  height: "19px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  flexShrink: 0,
                  border: "1px solid #e5e7eb",
                }}
              />
            ) : (
              <div
                style={{
                  width: "19px",
                  height: "19px",
                  borderRadius: "50%",
                  backgroundColor: "#f3f4f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "#6b7280",
                  flexShrink: 0,
                }}
              >
                {displayName !== "-"
                  ? displayName?.charAt(0)?.toUpperCase()
                  : "?"}
              </div>
            )}

            <div
              className="text_medium"
              style={{
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
                lineHeight: "1.5",
              }}
            >
              {displayName}
            </div>
          </div>
        );
      }

      case "edited_by": {
        const user = feature?.updated_by;

        // Extract display name, assuming 'value' is available in your switch scope.
        // If not, it falls back to "-"
        const displayName = user?.full_name || user?.name || value || "-";

        // Extract avatar URL
        const smallAvatar =
          user?.profile_picture?.url_compressed || user?.profile_picture?.url;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              overflow: "hidden",
            }}
            title={displayName !== "-" ? displayName : ""}
          >
            {smallAvatar ? (
              <img
                src={smallAvatar}
                alt={displayName}
                style={{
                  width: "19px",
                  height: "19px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  flexShrink: 0,
                  border: "1px solid #e5e7eb",
                }}
              />
            ) : (
              <div
                style={{
                  width: "19px",
                  height: "19px",
                  borderRadius: "50%",
                  backgroundColor: "#f3f4f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "#6b7280",
                  flexShrink: 0,
                }}
              >
                {displayName !== "-"
                  ? displayName?.charAt(0)?.toUpperCase()
                  : "?"}
              </div>
            )}

            <div
              className="text_medium"
              style={{
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
                lineHeight: "1.5",
              }}
            >
              {displayName}
            </div>
          </div>
        );
      }

      case "image":
        return (
          <div>
            <img
              src={typeof value === "string" ? value : ""}
              alt={field.name || "Image"}
              className="photo_popup"
            />
          </div>
        );

      case "document":
        // --- FIX: Check for valid string before rendering the anchor tag ---
        if (typeof value !== "string" || !value.trim()) {
          return <div className="text_medium sub_color">-</div>;
        }

        return (
          <div>
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              className="button_small button_white outline_black text_left"
            >
              Download doc
            </a>
          </div>
        );

      case "link":
        // --- FIX: Check for valid string before rendering the anchor tag ---
        if (typeof value !== "string" || !value.trim()) {
          return <div className="text_medium sub_color">-</div>;
        }

        const href =
          !value.includes("https://") && !value.includes("http://")
            ? `https://${value}`
            : value;

        return (
          <>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="button_small button_white outline_black text_left"
            >
              View link to {safeStringify(value)}
            </a>
            <br />
          </>
        );

      case "textarea":
        return (
          <>
            <div
              style={{
                maxHeight: "100px",
                overflowY: "hidden",
                border: "1px solid #ccc",
                padding: "8px",
                whiteSpace: "pre-wrap",
              }}
            >
              {safeStringify(value)}
            </div>
            <button
              className="button_small button_white outline_black text_left"
              onClick={() => {
                toggle_desc(safeStringify(value));
              }}
            >
              Perbesar
            </button>
            <br />
          </>
        );

      case "table":
        return (
          <div>
            <button
              className="button_small background_black"
              onClick={() => handleFullScreen()}
            >
              Buka tabel
            </button>
          </div>
        );

      default:
        return <div className="text_medium">{safeStringify(value)}</div>;
    }
  };

  //content
  const modal_desc_content = modal_desc && (
    <Modal modalSize="small" isOpen={modal_desc} onClose={() => toggle_desc()}>
      <div className="box-body" id="box-body">
        <div className="container background_white outline_black margin_bottom_extra text_medium sub_color">
          {typeof value_state === "object"
            ? JSON.stringify(value_state)
            : value_state}
        </div>
        <button
          className="button_big button_white outline_shadow_soft"
          onClick={() => toggle_desc()}
        >
          Tutup
        </button>
      </div>
    </Modal>
  );

  return (
    <main id={`popup_${properties?.key}`}>
      {modal_desc_content}
      <div
        style={{
          position: "sticky",
          top: "0",
          background: "white",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0",
        }}
      >
        <button
          className="button_small background_black text_left"
          onClick={() => handleFullScreen()}
        >
          Perbesar
        </button>
        <button className="button_circle_2 background_black" onClick={onClose}>
          X
        </button>
      </div>

      <section
        style={{
          width: "200px",
          maxWidth: "80vw",
          maxHeight: "200px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {type_2 === "banjir" && (
          <button
            className="button button_white outline_black text_left marginTop_10"
            onClick={onBanjirGenerate}
          >
            Generate Genangan
          </button>
        )}

        {filteredFields.map((field, index) => {
          const value = properties?.[field?.key];

          return (
            <React.Fragment key={field?.key || index}>
              <div className="container background_grey_light margin_bottom margin_top">
                <p className="text_small sub_color">{field?.name}</p>
                {renderFieldValue(field, value)}
              </div>
            </React.Fragment>
          );
        })}
      </section>
    </main>
  );
};

export default POPUP_SMALL;
